import React from 'react';
import { ReactComponent as ShopButton } from '../../assets/svgs/shop-button.svg'

import './shop.scss';

function Shop(props) {
  const { closeEnv } = props;

  return (
    <div className="shop-wrapper">
      <a className="shop-link" href="https://gabyyy.com/cardinal-risographs" target="_blank">
        <ShopButton />
      </a>
    </div>
  );
}

export default Shop;
